// extracted by mini-css-extract-plugin
export default {"companyContainer":"gN-z","companyImage":"hN-z","container":"iN-z","heading":"jN-z","darkText":"kN-z","smallHeading":"lN-z","darkBackground":"mN-z","whiteBackground":"nN-z"};